import React, { useContext, useEffect, useMemo } from 'react'
import { Switch } from 'react-router-dom'
import useUser from '../../contexts/hooks/useUser'
import { ModalContext } from '../../contexts/ModalContext'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import { UserContext } from '../../contexts/UserContext'
import usePreference from '../../utils/preferences/usePreference'
import Sidebar from '../layout/Sidebar'

export function encodeBase64(input: string): string {
	if (typeof window !== 'undefined' && window.btoa) {
		return window.btoa(input)
	}

	// Node.js fallback
	return Buffer.from(input, 'utf-8').toString('base64')
}

// Decoding a base64 string
export function decodeBase64(input: string): string {
	if (typeof window !== 'undefined' && window.atob) {
		return window.atob(input)
	}

	// Node.js fallback
	return Buffer.from(input, 'base64').toString('utf-8')
}

const WebAppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { insertModal } = useContext(ModalContext)
	const { hasObjects } = useContext(ObjectContext)
	const { skipLogin } = useContext(UserContext)

	const { user } = useUser()

	const [postEnodeLinkRedirect, setPostEnodeLinkRedirect] = usePreference(
		'postEnodeLinkRedirect',
		null
	)

	useEffect(() => {
		const getRedirect = async () => {
			if (postEnodeLinkRedirect && insertModal) {
				insertModal(postEnodeLinkRedirect)
				// Clear after using
				setPostEnodeLinkRedirect(null)
			}
		}

		getRedirect()
	}, [postEnodeLinkRedirect, insertModal, setPostEnodeLinkRedirect])

	const shouldShowNavigation = useMemo(() => {
		// Todo DRY This
		if (skipLogin) return true
		if (user?.email && user.email.includes('@')) return true

		return false
	}, [skipLogin, user, hasObjects])

	return (
		<div className='flex h-screen overflow-hidden'>
			{shouldShowNavigation ? <Sidebar /> : null}
			<main
				className={`
                flex-1 overflow-auto relative px-layout-sm sm:px-layout-md lg:px-layout-lg
                ${
									shouldShowNavigation
										? 'ml-[240px] sm:ml-[260px] md:ml-[280px] lg:ml-[300px] xl:ml-[320px]'
										: 'ml-0'
								}
            `}
			>
				<Switch>{children}</Switch>
			</main>
		</div>
	)
}

export default WebAppLayout
